<template>

    <form ref="estagiosequencia-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="estagioId">Próximo estágio</label>
                <select v-select="{ dataitem: 'Estagio', default: 'Selecione', filters: { attributeBehavior: 'ProximoEstagio' } }" v-model="model.proximoEstagioId" class="form-control" name="proximoEstagioId" required></select>
            </div>

            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="geraNovaTurma" class="custom-control-input" v-model="model.geraNovaTurma">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Gera Turma?</span>
                </label>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estagiosequencia-form-create",
        mixins: [base],
        props: { estagioId: Number },
        data: () => ({

            model: {
                proximoEstagioId: ""
            },

            form: "estagiosequencia-form-create",

            resources: {
                create: 'estagiosequencia',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;
                this.model.estagioId = this.estagioId;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

